module.exports = __webpack_public_path__ + "static/media/node-3.1f4793c2.svg";